import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ index, label, title, className = "" }) => (
  <Reveal className={className}>
    <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-cyan-300/90">
      <span className="h-px w-8 bg-gradient-to-r from-cyan-400/70 to-transparent" />
      {index} — {label}
    </p>
    <h2 className="mt-5 max-w-2xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
      {title}
    </h2>
  </Reveal>
);
